import * as _ from "lodash"
import {
    WB_CustomerRow,
    WB_FinishedProductRow,
    WB_ModelCoefficientSetRow,
    WB_ProductGroupRow
} from "../PA.Core/PAdbSchemaRows";
import { PAdbContext } from "../PA.Core/PAdbContext";
import {
    esWB_Customer, esWB_Finished_Product,
    esWB_Model_Coeff_Set,
    esWB_Model_Coeff_SetR, esWB_Product_Group
} from "../PA.Core/PAdbSchema";
import { PASearch } from "../PA.Core/PASearch";


export interface ICoefficientSetSubModel {
    Customer: WB_CustomerRow,
    ProductGroup: WB_ProductGroupRow,
    Product: WB_FinishedProductRow
}

export interface ICoefficientSetMasterData {
    CoefficientSet: WB_ModelCoefficientSetRow
    Customers: WB_CustomerRow[]
    ProductGroups: WB_ProductGroupRow[]
    Products: WB_FinishedProductRow[]
    SubModels?: ICoefficientSetSubModel[]
}

export class CoefficientSetUtils {
    static async getCoefficientSetMasterData(wbCoefficientSetId: number,
                                             dbContext?: PAdbContext,
                                             bIncludeSubModels?: boolean): Promise<ICoefficientSetMasterData> {
        let dataStore = dbContext
        if (_.isEmpty(dataStore))
            dataStore = new PAdbContext()

        const rv: ICoefficientSetMasterData = {
            CoefficientSet: undefined,
            Customers: [],
            ProductGroups: [],
            Products: []
        }

        if (!(wbCoefficientSetId > 0))
            return rv

        rv.CoefficientSet = <WB_ModelCoefficientSetRow>await dataStore.find(esWB_Model_Coeff_Set, wbCoefficientSetId)
        if (_.isEmpty(rv.CoefficientSet))
            return rv

        const custs = await PASearch.find(esWB_Model_Coeff_SetR,
            { WB_MODEL_COEFF_SET_ID: rv.CoefficientSet.cif.WB_MODEL_COEFF_SET_ID, DELETED_IND: { neq: '1' } },
            {}, [], 0, ['WB_CUST_ID'])


        const prds = await PASearch.find(esWB_Model_Coeff_SetR,
            { WB_MODEL_COEFF_SET_ID: rv.CoefficientSet.cif.WB_MODEL_COEFF_SET_ID, DELETED_IND: { neq: '1' } },
            {}, [], 0, ['WB_PRDGRP_ID', 'WB_PROD_ID'])


        const arrWbCustIds = _.filter(_.map(custs, (a) => +a.WB_CUST_ID), (b) => b > 0)
        const arrWbPrdGrpIds = _.filter(_.map(prds, (a) => +a.WB_PRDGRP_ID), (b) => b > 0)
        let arrWbProdIds = _.filter(_.map(prds, (a) => +a.WB_PROD_ID), (b) => b > 0)
        let bProductType = false

        if (arrWbCustIds.length)
            rv.Customers = <WB_CustomerRow[]>await dataStore.findUsingCache(esWB_Customer, arrWbCustIds)

        if (arrWbPrdGrpIds.length)
            rv.ProductGroups = <WB_ProductGroupRow[]>await dataStore.findUsingCache(esWB_Product_Group, arrWbPrdGrpIds)

        if (arrWbProdIds.length) {
            rv.Products = <WB_FinishedProductRow[]>await dataStore.findUsingCache(esWB_Finished_Product, arrWbProdIds)
            if (!_.isEmpty(rv.ProductGroups))
                bProductType = true
        }


        if (_.isEmpty(arrWbProdIds) && _.isEmpty(rv.ProductGroups)) {
            arrWbProdIds = arrWbPrdGrpIds
            rv.Products = <WB_FinishedProductRow[]>await dataStore.findUsingCache(esWB_Finished_Product, arrWbProdIds)
            bProductType = true
        }

        if (bIncludeSubModels) {
            const subModels = await PASearch.find(esWB_Model_Coeff_SetR,
                { WB_MODEL_COEFF_SET_ID: rv.CoefficientSet.cif.WB_MODEL_COEFF_SET_ID, DELETED_IND: { neq: '1' } },
                {}, [], 0, ['WB_CUST_ID', 'WB_PRDGRP_ID', 'WB_PROD_ID'])

            const dctCst = _.keyBy(rv.Customers, (a) => a.cif.WB_CUST_ID)
            const dctPrdGrp = _.keyBy(rv.ProductGroups, (a) => a.cif.WB_PRDGRP_ID)
            const dctPrd = _.keyBy(rv.Products, (a) => a.cif.WB_PROD_ID)

            rv.SubModels = _.map(subModels, (a) => {
                if (!bProductType)
                    return {
                        Customer: dctCst[a.WB_CUST_ID],
                        ProductGroup: dctPrdGrp[a.WB_PRDGRP_ID],
                        Product: dctPrd[a.WB_PROD_ID]
                    }
                if (a.WB_PROD_ID > 0)
                    return {
                        Customer: dctCst[a.WB_CUST_ID],
                        ProductGroup: dctPrdGrp[a.WB_PRDGRP_ID],
                        Product: dctPrd[a.WB_PROD_ID]
                    }
                return {
                    Customer: dctCst[a.WB_CUST_ID],
                    ProductGroup: dctPrdGrp[a.WB_PRDGRP_ID],
                    Product: dctPrd[a.WB_PRDGRP_ID]
                }
            })
            rv.SubModels = _.filter(rv.SubModels, (a) => !_.isEmpty(a.Customer) || !_.isEmpty(a.ProductGroup) || !_.isEmpty(a.Product))
        }
        return rv

    }


}